var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?23b8dd2cd51f42dbc3d2dbef9e5c1c49";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();


// WEBPACK FOOTER //
// ./src/common/baidu.js